import React from 'react';
import { BOOKING_STEPS } from '../../../utils/labTestUtils';

export default function BookingStepper({ currentStep }) {
  return (
    <nav className="lab-stepper fade-in-up" aria-label="Booking progress">
      {BOOKING_STEPS.map((step, i) => {
        const done   = currentStep > step.id;
        const active = currentStep === step.id;
        return (
          <div
            key={step.id}
            className={`lab-stepper-item${done ? ' is-complete' : ''}${active ? ' is-active' : ''}`}
          >
            <div className="lab-stepper-node" aria-current={active ? 'step' : undefined}>
              {done ? '✓' : step.id}
            </div>
            <div className="lab-stepper-text">
              <div className="lab-stepper-label">{step.label}</div>
              <div className="lab-stepper-hint">{step.hint}</div>
            </div>
            {i < BOOKING_STEPS.length - 1 && <div className="lab-stepper-line" aria-hidden />}
          </div>
        );
      })}
    </nav>
  );
}
